import { render, staticRenderFns } from "./StripePaymentMethod.vue?vue&type=template&id=1074f5fa&scoped=true"
import script from "./StripePaymentMethod.vue?vue&type=script&lang=js"
export * from "./StripePaymentMethod.vue?vue&type=script&lang=js"
import style0 from "./StripePaymentMethod.vue?vue&type=style&index=0&id=1074f5fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1074f5fa",
  null
  
)

export default component.exports